import { render, staticRenderFns } from "./CoTwoMealForm.vue?vue&type=template&id=12bd22ec&scoped=true&"
import script from "./CoTwoMealForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoMealForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd22ec",
  null
  
)

export default component.exports